import React from 'react';
import '../styles.scss';

// Ширины плашек берём из фиксированного набора, а не случайно: случайные значения
// менялись бы на каждом рендере и скелетон бы «дёргался».
const LABEL_WIDTHS = [72, 108, 86, 124, 94, 66, 112, 80];
const CHIP_WIDTHS = [64, 92, 48, 110, 76, 58, 132, 70, 88, 54, 100, 62];

const widthAt = (widths: number[], index: number) => widths[index % widths.length];

export const SkeletonBlock: React.FC<{ className?: string; style?: React.CSSProperties }> = ({
  className,
  style,
}) => <div className={className ? `al-skeleton ${className}` : 'al-skeleton'} style={style} />;

// Дерево фильтров в сайдбаре: первая строка — заголовок группы, остальные с отступом,
// как дочерние узлы antd Tree.
export const TreeSkeleton: React.FC<{ rows?: number }> = ({ rows = 6 }) => (
  <div className="al-skeleton-tree" aria-hidden>
    {Array.from({ length: rows }, (_, index) => (
      <div
        key={index}
        className="al-skeleton-tree__row"
        style={{ paddingLeft: index === 0 ? 0 : 24 }}
      >
        <SkeletonBlock
          className="al-skeleton-tree__label"
          style={{ width: index === 0 ? 96 : widthAt(LABEL_WIDTHS, index) }}
        />
      </div>
    ))}
  </div>
);

// Неопределённый прогресс для обновления уже показанных данных: занимает 2px сверху
// у ближайшего позиционированного родителя и ничего не перекрывает.
export const ProgressBar: React.FC = () => (
  <div className="al-progress-bar" aria-hidden>
    <div className="al-progress-bar__indicator" />
  </div>
);

// Строка тегов над списком ассетов.
export const TagsSkeleton: React.FC<{ count?: number }> = ({ count = 12 }) => (
  <div className="al-skeleton-tags" aria-hidden>
    {Array.from({ length: count }, (_, index) => (
      <SkeletonBlock
        key={index}
        className="al-skeleton-chip al-skeleton-tags__chip"
        style={{ width: widthAt(CHIP_WIDTHS, index) }}
      />
    ))}
  </div>
);

// Информация об ассете в правом сайдбаре: имя, строки свойств и блок тегов.
export const DetailsSkeleton: React.FC = () => (
  <div className="al-skeleton-details" aria-hidden>
    <SkeletonBlock className="al-skeleton-details__name" />
    <div className="al-skeleton-details__rows">
      {Array.from({ length: 5 }, (_, index) => (
        <SkeletonBlock
          key={index}
          className="al-skeleton-details__row"
          style={{ width: widthAt(LABEL_WIDTHS, index + 1) + 40 }}
        />
      ))}
    </div>
    <div className="al-skeleton-details__tags">
      {Array.from({ length: 5 }, (_, index) => (
        <SkeletonBlock
          key={index}
          className="al-skeleton-chip al-skeleton-details__chip"
          style={{ width: widthAt(CHIP_WIDTHS, index + 2) }}
        />
      ))}
    </div>
  </div>
);
